import styled from '@emotion/styled';
import React, { FC } from 'react';
import { handyBreakpoint } from '~Styles/breakpoints';
import scanImg from '~Assets/Images/scaninfo.png';
import { useButton, useI18n } from '~Hooks';
import { BlueButton } from '~Styles';
import Heading from '~ComponentsImproved/Typography/Heading';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import { addToast } from '~/actions';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 12px rgb(0 0 0 / 20%), 0px 20px 32px rgb(0 0 0 / 20%),
    0px 0px 40px rgb(0 0 0 / 16%);
  border-radius: 8px;
  box-sizing: border-box;
  min-height: 248px;
  overflow: auto;
`;

const InnerWrapper = styled.div`
  text-align: left;
  border-radius: 8px;
  padding: 44px 64px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  gap: 16px;
  min-height: 100%;

  ${handyBreakpoint} {
    padding: 44px 32px;
    flex-flow: column nowrap;
    gap: 8px;
  }
`;

const ImageRow = styled.div`
  display: flex;
  max-width: 500px;
  justify-content: center;
  align-items: center;

  img {
    max-width: 100%;
    max-height: 100%;
    height: auto;
    width: auto;
    object-fit: contain;
    margin: 0 -40px -40px;
  }

  ${handyBreakpoint} {
    flex-flow: column nowrap;
    gap: 8px;
  }
`;

const Content = styled.div`
  font-size: 20px;
  max-width: 400px;
  margin-top: 40px;

  ol {
    margin-top: 8px;
    font-weight: 600;
  }
`;

interface Props {
  startScan: () => void;
}

const ScanInfo: FC<Props> = ({ startScan }) => {
  const { i18n } = useI18n();
  const scanButton = useButton({
    onClick: startScan,
  });

  return (
    <Wrapper>
      <InnerWrapper>
        <ImageRow>
          <img src={scanImg} />
        </ImageRow>
        <Content>
          <Heading level={1}>{i18n('Settings.AddTerminalScan.Info.Title')}</Heading>
          <Paragraph level={2} top={16}>
            {i18n('Settings.AddTerminalScan.Info.Text')}
          </Paragraph>
          <Paragraph level={3} top={16}>
            {i18n('Settings.AddTerminalScan.Info.ToShow')}
          </Paragraph>
          <ol>
            <li>{i18n('Settings.AddTerminalScan.Info.Step1')}</li>
            <li>{i18n('Settings.AddTerminalScan.Info.Step2')}</li>
          </ol>
          <BlueButton {...scanButton}>{i18n('Settings.AddTerminalScan.Info.Button')}</BlueButton>
        </Content>
      </InnerWrapper>
    </Wrapper>
  );
};

export default ScanInfo;
